import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
export type DialogSize =
  | "mini"
  | "small"
  | "medium"
  | "small-medium"
  | "large"
  | "x-large"
  | "full";

interface DialogProps {
  dialogVisible: boolean;
  size: DialogSize;
  title: string;
  fullscreen?: boolean;
  top?: string;
  rounded?: boolean;
  showCloseButton?: boolean;
  closeOnClickModal?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'base-dialog',
  props: {
    dialogVisible: { type: Boolean },
    size: { default: "small" },
    title: null,
    fullscreen: { type: Boolean, default: false },
    top: { default: "15vh" },
    rounded: { type: Boolean },
    showCloseButton: { type: Boolean, default: true },
    closeOnClickModal: { type: Boolean, default: true }
  },
  emits: {
  close: () => true,
  open: () => true,
},
  setup(__props: any, { emit }) {

const props = __props as { dialogVisible: boolean, size: DialogSize, title: string, fullscreen: boolean, top: string, rounded?: boolean, showCloseButton: boolean, closeOnClickModal: boolean }



const customClass = computed(() => {
  let customClass = props.size;

  if (props.rounded) {
    customClass += " rounded";
  }

  return customClass;
});



const width = computed(() => {
  switch (props.size) {
    case "mini":
      return "20%";
    case "small":
      return "30%";
    case "small-medium":
      return "40%";
    case "medium":
      return "50%";
    case "large":
      return "80%";
    case "x-large":
      return "90%";
    case "full":
      return "98%";
    default:
      return "30%";
  }
});

const handleClose = (done: any) => {
  emit("close");
  done();
};

return { __sfc: true,props, customClass, emit, width, handleClose }
}

})